/* eslint-disable no-console */
const logger = {
  debug: (...messages: any) => {
    process.env.NODE_ENV === "development" && console.log(...messages);
  },
  error: (...messages: any) => {
    process.env.NODE_ENV === "development" && console.error(...messages);
  },
  warn: (...messages: any) => {
    process.env.NODE_ENV === "development" && console.warn(...messages);
  },
};
/* eslint-enable no-console */

export default logger;
